var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#e2e2e2"}},[_vm._m(0),_c('Brochure'),_c('ContactForm'),_c('ContactBanner')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-solutions"},[_c('span',{staticClass:"header-font"},[_vm._v("Soluciones")])])
}]

export { render, staticRenderFns }